module.exports = __webpack_public_path__ + "img/phizer.01edb28d.png";